import React, { useMemo } from "react";
import KC_UIText from "../typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../ds_commons";
import "./styles.scss";
import NiceModal from "@ebay/nice-modal-react";
import PlanOptionModal from "../../components/modal/PlanOption/PlanOptionModal";
import { getPaddingClass } from "./component/helper/helper";
import { buildCls } from "../../utils/helpers/buildCls";
import { KC_CardTitleSection } from "./component/KC_CardTitleSection";
import { KC_CardProps } from "./component/model/KC_CardProps";
import { KC_PaddingEnum } from "./component/model/KC_PaddingEnum";

const KC_Card: React.FC<KC_CardProps> = (props) => {
  const useMask = props.useMask ?? false;
  const className = props.className ?? "";
  const padding = props.padding ?? KC_PaddingEnum.default;
  const boxShadow = props.boxShadow ?? false;
  const useTwicpic = props.useTwicPics ?? false;

  const customClassName = useMemo(() => {
    const cls = [
      "kc-card",
      "gap-sm",
      className,
      boxShadow ? "kc-card-shadow" : "",
      props.onClick != null ? "cursor-pointer" : "none",
      useMask ? "kc-card-upsell" : "",
      props.isCTACard ? "kc-card-cta" : "",
      props.isGiftCard ? "kc-gift-cta" : "",
      props.isGameCardPreview ? "kc-game-card-preview" : ""
    ];
    return buildCls(cls);
  }, [className, boxShadow, useMask, props.onClick]);

  return (
    <div
      id={props.id}
      className={customClassName + getPaddingClass(padding)}
      style={{ ...props.extraStyle }}
      onClick={
        useMask
          ? async () => {
              await NiceModal.show(PlanOptionModal);
            }
          : props.onClick
      }
      tabIndex={props.tabIndex}
    >
      <KC_CardTitleSection
        title={props.title}
        titleClassName={props.titleClassName}
        useRemove={props.canDelete}
        handleRemove={props.handleDelete}
        image={props.image}
        imgId={props.imgId}
        useTwicpic={useTwicpic}
        useMask={useMask}
        onMaskClick={props.onMaskClick}
        logoURL={props.logoURL}
        companyName={props.companyName}
        isSelected={props.isSelected}
        forceShowHeader={props.forceShowHeader}
        isOnboarding={props.isOnboarding}
      />
      {props.description && (
        <span className="description">
          <KC_UIText weight={KC_Weights.reg} text={props.description} />
        </span>
      )}
      {props.children}
    </div>
  );
};

export default KC_Card;
